import {
  BrandCompanyMappingType,
  BrandCompanyMappingActionsList,
} from "../actions/brandCompanyMappingActions";
import { Action } from "../actions/types";

const initialValue: Array<BrandCompanyMappingType> = [];

export const BrandCompanyMappingReducer = (
  state: BrandCompanyMappingType[] = initialValue,
  action: Action
) => {
  switch (action.type) {
    case BrandCompanyMappingActionsList.ADD_BRAND_MAPPING: {
      return [...state, action.data];
    }

    case BrandCompanyMappingActionsList.EDIT_BRAND_MAPPING: {
      const updated = [...state].slice();
      const index = updated.findIndex((u) => u.id === action.data.id);

      if (index > -1) {
        updated[index] = {
          ...action.data,
        };
      }

      return updated;
    }

    case BrandCompanyMappingActionsList.FETCH_BRAND_MAPPING: {
      return action.data;
    }

    case BrandCompanyMappingActionsList.DELETE_BRAND_MAPPING: {
      return state.filter((i) => i.id !== action.data.id);
    }

    case BrandCompanyMappingActionsList.CLEAR_BRAND_MAPPING: {
      return initialValue;
    }

    default:
      return state;
  }
};
